// Libraries
import { FormElems, Alert, ConditionalComponent } from '../';
import {
    createRoleRequest,
    createRoleReset,
    updateRoleRequest,
    updateRoleReset,
} from '../../containers/RoleManagement/redux/roleManagement.actions';
import {
    getRoleStatusOptions,
    capitaliseString,
} from '../../utils/helperMethods';
import validate from './validator';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { camelCase, isEmpty, startCase } from 'lodash';
import { useDispatch } from 'react-redux';

//  Components

// Actions

// Helper Methods

// Validator

// Styles
import './createRoleForm.scss';

/**
 * CreateRoleForm Component
 *
 * @param {Object} props - React component props
 */

// eslint-disable-next-line max-lines-per-function
const CreateRoleForm = props => {
    const {
        handleSubmit,
        actions,
        closePopup,
        roleManagementData,
        fetchData,
        formData,
        actionType,
        resetPage,
        roleData,
    } = props;

    const isViewMode = actionType === 'view';
    const isEditMode = actionType === 'edit';

    const {
        createRole,
        allResourcePermissionDetails,
        updateRole,
    } = roleManagementData;

    const subPermissionMap = {};
    const dispatch = useDispatch();

    allResourcePermissionDetails.forEach(resource => {
        resource.permissionDetail.forEach(permission => {
            if (
                permission.permissionName &&
                permission.subPermissionDetails &&
                permission.subPermissionDetails.length
            ) {
                subPermissionMap[permission.permissionId] = {
                    permissionName: permission.permissionName,
                    subPermissionDetails: permission.subPermissionDetails || [],
                };
            }
        });
    });

    /* Effect is to show the success message */
    useEffect(() => {
        if (createRole.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closePopup, createRole.isSuccess]);

    useEffect(() => {
        if (updateRole.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            resetPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, updateRole.isSuccess]);

    useEffect(() => {
        // Reset data
        return () => {
            actions.createRoleReset();
            actions.updateRoleReset();
        };
    }, []);

    const roleStatusOptions = getRoleStatusOptions();

    function handleFormSubmit(data) {
        const values = data;
        const reqPayload = {};

        reqPayload.roleName = values.roleName;
        reqPayload.roleStatus = values.roleStatus;

        const resourceDetail = [];

        allResourcePermissionDetails.forEach(resource => {
            if (values[resource.resourceName]) {
                const resourceData = {
                    resourceId: resource.resourceId,
                    resourceName: resource.resourceName,
                };

                let permissionDetail = [];

                resource.permissionDetail.forEach(permission => {
                    if (
                        values[resource.resourceName].includes(
                            permission.permissionId
                        )
                    ) {
                        let permissionData = {
                            permissionName: permission.permissionName,
                            permissionId: permission.permissionId,
                        };

                        let subPermissions = [];

                        if (
                            permission.subPermissionDetails &&
                            values['subPermissions'] &&
                            values['subPermissions'][permission.permissionName]
                        ) {
                            permission.subPermissionDetails.map(
                                subPermissionDetails => {
                                    if (
                                        values.subPermissions &&
                                        values.subPermissions[
                                            permission.permissionName
                                        ] &&
                                        Array.isArray(
                                            values.subPermissions[
                                                permission.permissionName
                                            ]
                                        ) &&
                                        values.subPermissions[
                                            permission.permissionName
                                        ].includes(
                                            subPermissionDetails.permissionId
                                        )
                                    ) {
                                        subPermissions.push({
                                            permissionName:
                                                subPermissionDetails.permissionName,
                                            permissionId:
                                                subPermissionDetails.permissionId,
                                        });
                                    }
                                }
                            );
                        }

                        if (subPermissions && subPermissions.length) {
                            permissionData[
                                'subPermissionDetails'
                            ] = subPermissions;
                        }

                        permissionDetail.push(permissionData);
                    }
                });

                if (permissionDetail.length > 0) {
                    resourceData.permissionDetail = permissionDetail;
                    resourceDetail.push(resourceData);
                }
            }
        });

        reqPayload.resourceDetail = resourceDetail;

        // return;
        if (isEditMode) {
            reqPayload.roleId = roleData.roleId;
            reqPayload.comment = data.remarks;
            actions.updateRoleRequest(reqPayload);
        } else {
            actions.createRoleRequest(reqPayload);
        }
    }
    const errorMessage = updateRole.message || createRole.message;

    const values = formData?.values;
    /**runs when page loads or there is any change when the resourceName is edit_merchant_onboarding */

    useEffect(() => {
        const selectedPermissions = formData?.values?.edit_merchant_onboarding || [];
        let updatedPermissions = new Set(selectedPermissions); 
        //mapping dependancies.
        const keyPermissions=[
            {
                key: "edit_merchant",
                value: "view_merchant"
            },
            {
                key: "edit_pg_configuration",
                value: "view_pg_configuration"
            },{
                key: "edit_settlement",
                value: "view_settlement_view"
            },{
                key: "edit_surcharge",
                value: "view_surcharge"
            },{
                key: "edit_dynamic_routing",
                value: "view_dynamic_routing"
            },{
                key: "edit_kyc",
                value: "view_kyc"
            },{
                key: "edit_payment_mode",
                value: "view_payment_mode"
            },
            {
                key: "edit_integration",
                value: "view_integration"
            },{
                key: "edit_notification",
                value: "view_notification"
            },
            {
                key: "update_mle",
                value: "fetch_mle"
            },
            {
                key:"edit_tid",
                value: "view_tid"
            }
        ]
        let permissionDetail=[];
        allResourcePermissionDetails.filter(item => { return (item.resourceName === 'edit_merchant_onboarding') })
            .map(
                item => { permissionDetail = [...permissionDetail, ...item.permissionDetail] });
        // console.log("permissionDetail",permissionDetail);
        let permissionIdMap = {}; 
        permissionDetail.map(item => {
            permissionIdMap[item.permissionName] = item.permissionId;
        })
        // console.log("permissionIdMap",permissionIdMap);
       
        
        let dependencyMap = {} 
        keyPermissions.map(item => {
            dependencyMap[permissionIdMap[item.key]] = permissionIdMap[item.value]
        })
        // console.log("depandancy Map",dependencyMap)
    
        selectedPermissions.forEach(permission => {
            const dependency = dependencyMap[Number(permission)];
            if (dependencyMap[permission]) {
                updatedPermissions.add(dependency); 
            }
        });
    
        const resultArray = Array.from(updatedPermissions);
    
        if (resultArray.length !== selectedPermissions.length) {
            dispatch(change('create-role', 'edit_merchant_onboarding', resultArray));
        }
        console.log("1111", resultArray);
        console.log("2222", formData)
    }, [formData?.values?.edit_merchant_onboarding, dispatch]);

    return (
        <form
            className="role-view-edit"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="form-section">
                <div className="form-section">
                    <ConditionalComponent isVisible={!isEditMode}>
                        <div className="form-field">
                            <p className="label">Role Name</p>
                            <Field
                                name="roleName"
                                type="text"
                                component={FormElems.Input}
                                placeholder="Enter Role Name"
                                disabled={isViewMode}
                            />
                        </div>
                    </ConditionalComponent>
                </div>
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <Field
                        name="roleStatus"
                        options={roleStatusOptions}
                        valueField="value"
                        labelField="label"
                        component={FormElems.Radio}
                        placeholder="Enter Role Name"
                        disabled={isViewMode}
                    />
                </div>
            </div>
            <div className="management-section">
                <ConditionalComponent
                    isVisible={
                        allResourcePermissionDetails &&
                        allResourcePermissionDetails.length
                    }
                >
                    {allResourcePermissionDetails.map(
                        (
                            {
                                resourceId,
                                resourceName,
                                labelName,
                                permissionDetail,
                            },
                            index
                        ) => {
                            return (
                                <div className="resource-container">
                                    <div className="form-section permission-form-section">
                                        <p className="label">
                                            {labelName ||
                                                startCase(
                                                    camelCase(resourceName)
                                                )}
                                        </p>
                                        <div className="form-field">
                                            <Field
                                                name={resourceName}
                                                options={permissionDetail.map(item => ({
                                                    ...item,
                                                    displayLabel: item.labelName || item.permissionName
                                                }))}
                                                valueField="permissionId"
                                                labelField="displayLabel"
                                                component={FormElems.Checkbox}
                                                wrapperClass="permission-checkbox"
                                                isDisabled={isViewMode}
                                                // handleChange={handleClickEvent}
                                            />
                                        </div>
                                    </div>
                                    <ConditionalComponent
                                        isVisible={
                                            values &&
                                            values[resourceName] &&
                                            values[resourceName].length > 0
                                        }
                                    >
                                        <div className="sub-permission">
                                            {values &&
                                                values[resourceName] &&
                                                values[resourceName].map(
                                                    selectedPermissionId => {
                                                        const subPermissionDetails =
                                                            subPermissionMap[
                                                                selectedPermissionId
                                                            ];

                                                        if (
                                                            subPermissionDetails
                                                        ) {
                                                            return (
                                                                <>
                                                                    <div className="form-section">
                                                                        <p className="label">
                                                                            {subPermissionDetails.labelName ||
                                                                                startCase(
                                                                                    camelCase(
                                                                                        subPermissionDetails.permissionName
                                                                                    )
                                                                                )}
                                                                        </p>
                                                                        <div className="form-field">
                                                                            <Field
                                                                                name={`subPermissions.${subPermissionDetails.permissionName}`}
                                                                                id={`subPermissions.${subPermissionDetails.permissionName}`}
                                                                                options={
                                                                                    subPermissionDetails.subPermissionDetails
                                                                                }
                                                                                valueField="permissionId"
                                                                                labelField="labelName"
                                                                                component={
                                                                                    FormElems.Checkbox
                                                                                }
                                                                                wrapperClass="permission-checkbox"
                                                                                isDisabled={
                                                                                    isViewMode
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            );
                                                        }
                                                    }
                                                )}
                                        </div>
                                    </ConditionalComponent>
                                </div>
                            );
                        }
                    )}
                </ConditionalComponent>
                <ConditionalComponent isVisible={isEditMode}>
                        <div className="form-section">
                            <div className="form-field">
                                <p className="label">Remarks</p>
                                <Field
                                    wrapperClass="comment-input"
                                    name="remarks"
                                    type="textarea"
                                    isDisabled={isViewMode}
                                    component={FormElems.TextArea}
                                    placeholder="Enter Comment "
                                />
                            </div>
                        </div>
                    </ConditionalComponent>
            </div>
            {errorMessage ? <Alert>{errorMessage}</Alert> : null}
            <ConditionalComponent isVisible={!isViewMode}>
                <div className="form-section action">
                    <div className="cancel-btn" onClick={() => closePopup()}>
                        CANCEL
                    </div>
                    <FormElems.Button
                        buttonType="primary"
                        isDisable={formData && isEmpty(formData.values)}
                        text="SUBMIT"
                    />
                </div>
            </ConditionalComponent>
        </form>
    );
};

const mapStateToProps = ({ auth, roleManagementData, form }) => ({
    auth,
    roleManagementData,
    formData: form['create-role'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createRoleRequest,
            createRoleReset,
            updateRoleRequest,
            updateRoleReset,
        },
        dispatch
    ),
});

CreateRoleForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    closePopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    roleManagementData: PropTypes.object,
    formData: PropTypes.object,
    actionType: PropTypes.string,
    fetchData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'create-role',
        validate,
        enableReinitialize: true,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(CreateRoleForm);

